import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../../components/ui/table";
import { useNavigate } from "react-router";

const apiUrl = process.env.REACT_APP_API_URL;

export default function WorkflowCategoriesTable() {
  const token = localStorage.getItem("token");
  const [WorkflowCategories, setWorkflowCategories] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchWorkflowCategories = async () => {
    const response = await fetch(`${apiUrl}/workflows_categories`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token || "",
      },
    })
    const result = await response.json();
    console.log(result);
    if (result.success) {
      setWorkflowCategories(result.workflowsCategories);
    } else {
      setWorkflowCategories([]);
    }
  };

  useEffect(() => {
    fetchWorkflowCategories();
  }, []);

  const handleRowClick = (category: any) => {
    navigate('/update-workflow-category', { state: { category } });
  }

  return(
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Workflow Category Name
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Temperature Check
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {WorkflowCategories.map((category) => (
            <TableRow key={category.acwfcategory_id} className="cursor-pointer hover:bg-[#ffffa3]"  onClick={() => handleRowClick(category)}>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{category.name}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{category.wfcattype === 1 ? "Yes" : ""}</span>
              </TableCell>
            </TableRow>
            
          ))}
        </TableBody>
      </Table>
    </>
  )
}